let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eEcxx")).then(() => parcelRequire('ixBjC'));